export default __webpack_public_path__ + "161a81b3a15d92162869367db03d5ed8.gif";